<template>
    <div class="external-model">
        <ModelHeader />
        <ModelBody>
            <PreviewExternalModel
                v-if="!inEditMode"
                :isDeleting="isModelDeleting"
                :externalModel="getCurrent"
                @edit="inEditMode = true"
                @delete="deleteModel"
            />
            <EditExternalModel
                v-else
                :isDeleting="isModelDeleting"
                :isEditing="isModelUpdating"
                :externalModel="getCurrent"
                @edit="editExternalModel"
                @cancel="inEditMode = false"
                @delete="deleteModel"
            />
        </ModelBody>
    </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import ModelHeader from '../common/model_header'
import ModelBody from '../common/model_body'
import EditExternalModel from './edit-external-model'
import PreviewExternalModel from './preview-external-model'

export default {
  components: {
    ModelHeader,
    ModelBody,
    EditExternalModel,
    PreviewExternalModel
  },

  computed: {
    ...mapGetters('knowledgebase', ['getCurrent'])
  },

  data () {
    return {
      inEditMode: false,
      isModelDeleting: false,
      isModelUpdating: false
    }
  },

  methods: {
    ...mapActions('knowledgebase', ['initNluApplication']),
    ...mapActions('knowledgebase/customModels', ['updateCustomModel', 'deleteCustomModel']),

    async deleteModel () {
      this.isModelDeleting = true

      await this.deleteCustomModel(this.getCurrent.id)
      await this.initNluApplication()

      this.$router.push({ name: 'home' })
      this.isModelDeleting = false
    },

    async editExternalModel (data) {
      this.isModelUpdating = true
      await this.updateCustomModel(data)
      this.inEditMode = false
      this.isModelUpdating = false
    }
  }
}
</script>

<style scoped lang="scss">
    .external-model{
        display: flex;
        flex-direction: column;
        height: 100%;
        overflow: auto;
    }

    ::v-deep .model-body-wrap {
        max-width: 500px;
    }
</style>
